import { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import ClientMarquee from "../components/common/ClientMarquee";
import Contact from "../components/sections/Contact";
import slangLogo from "../assets/clients/slang.svg";
import openLogo from "../assets/clients/open-logo-w.png";
import royoLogo from "../assets/clients/royo-bread-co.png";
import fireflyLogo from "../assets/clients/firefly-vapor-w.png";
import wildSocietyLogo from "../assets/clients/ws-logo-w.png";
import alchemyLogo from "../assets/clients/alchemy-naturals-cbd.png";
import elevatePetLogo from "../assets/clients/elevate-pet.png";
import longplayLogo from "../assets/clients/longplay-wellness-w.png";
import merkleLogo from "../assets/clients/merkle-logo.svg";
import huskemawLogo from "../assets/clients/huskemaw-optics.png";
import greenDragonLogo from "../assets/clients/green-dragon-white.webp";
import livwellLogo from "../assets/clients/livwell.svg";
import everydayWeedLogo from "../assets/clients/everyday-weed-white.webp";
import barkbusLogo from "../assets/clients/barkbus-logo-b.png";
import starBudsLogo from "../assets/clients/star-buds-logo-w.svg";
import rhodeLogo from "../assets/clients/rhode.png";
import underArmourLogo from "../assets/clients/under-armour.svg";
import samsungLogo from "../assets/clients/samsung.svg";
import comcastLogo from "../assets/clients/comcast.svg";
import hexcladLogo from "../assets/clients/hexclad.svg";
import brownTee from "../assets/journal/brown-tee.webp";
import cannabisPlant from "../assets/journal/cannabis-plant.webp";
import ferns from "../assets/journal/ferns.webp";
import javascriptBird from "../assets/journal/javascript-bird.webp";
import mountainMuseum from "../assets/journal/mountain-museum.webp";
import palmFronds from "../assets/journal/palm-fronds.webp";
import reaperPattern from "../assets/journal/reaper-pattern.webp";
import smileySticker from "../assets/journal/smiley-sticker.webp";
import thePacific from "../assets/journal/the-pacific.webp";
import towerPalms from "../assets/journal/tower-palms.webp";
import openVapeWork from "../assets/work/open-vape.webp";
import barkbusWork from "../assets/work/barkbus.webp";
import elevatePetWork from "../assets/work/elevate-pet.jpeg";
import fireflyWork from "../assets/work/firefly.webp";
import wildSocietyWork from "../assets/work/wild-society.webp";
import "./Work.css";

const projects = [
  {
    id: 1,
    client: "Slang Worldwide",
    image: cannabisPlant,
    category: "Multi-Brand DTC",
    description: "Enterprise cannabis holding company — unified DTC strategy across 6 sub-brands with centralized analytics and fulfillment.",
    year: "2024",
    gradient: "linear-gradient(145deg, #0A0A0A 0%, #1a0800 35%, #E8450E 100%)",
    size: "full",
    logo: slangLogo,
  },
  {
    id: 2,
    client: "Open Vape",
    url: "https://openvapeshop.com",
    image: openVapeWork,
    category: "Shopify Plus",
    description: "Full platform migration to Shopify Plus with age-gated checkout and state-level compliance engine.",
    year: "2023",
    gradient: "linear-gradient(135deg, #0A0A0A 0%, #1a1410 50%, #B83500 100%)",
    size: "half",
    logo: openLogo,
  },
  {
    id: 3,
    client: "Firefly Vapor",
    url: "https://thefirefly.com",
    image: fireflyWork,
    category: "Compliance & Payments",
    description: "Payment processing overhaul and PACT Act compliance — keeping revenue flowing in a shifting regulatory landscape.",
    year: "2021",
    gradient: "linear-gradient(130deg, #0A0A0A 0%, #180800 45%, #FF6B35 100%)",
    size: "half",
    logo: fireflyLogo,
  },
  {
    id: 4,
    client: "Wild Society",
    url: "https://wildsocietynutrition.com",
    image: wildSocietyWork,
    category: "Functional Beverage",
    description: "Brand platform and ecommerce build for a functional energy drink line — bold identity, seamless shop experience.",
    year: "2024",
    gradient: "linear-gradient(150deg, #0A0A0A 0%, #14100a 45%, #C74A00 100%)",
    size: "half",
    logo: wildSocietyLogo,
  },
  {
    id: 5,
    client: "Alchemy Naturals",
    image: ferns,
    category: "CBD Wellness",
    description: "CBD wellness storefront with subscription bundles, lab-result transparency, and education-first product pages.",
    year: "2023",
    gradient: "linear-gradient(135deg, #0A0A0A 0%, #171006 45%, #E85D0E 100%)",
    size: "half",
    logo: alchemyLogo,
  },
  {
    id: 6,
    client: "LivWell",
    image: mountainMuseum,
    category: "Multi-Location Retail",
    description: "Enterprise dispensary chain — unified online menus, loyalty integration, and order-ahead flows across the retail footprint.",
    year: "2022",
    gradient: "linear-gradient(140deg, #0A0A0A 0%, #120b04 40%, #FF5A1F 100%)",
    size: "full",
    logo: livwellLogo,
    logoInvert: true,
  },
  {
    id: 7,
    client: "Barkbus",
    image: barkbusWork,
    category: "Service Booking",
    description: "Luxury mobile dog grooming — booking-first web experience, market-by-market landing pages, and conversion optimization.",
    year: "2024",
    gradient: "linear-gradient(160deg, #0A0A0A 0%, #190c02 50%, #D64500 100%)",
    size: "half",
    logo: barkbusLogo,
    logoInvert: true,
  },
  {
    id: 8,
    client: "Star Buds",
    image: smileySticker,
    category: "Retail Ecommerce",
    description: "Dispensary retail network — localized store pages, online menu integration, and SEO-driven foot traffic growth.",
    year: "2021",
    gradient: "linear-gradient(125deg, #0A0A0A 0%, #150a03 45%, #F26522 100%)",
    size: "half",
    logo: starBudsLogo,
  },
  {
    id: 9,
    client: "Elevate Pet",
    image: elevatePetWork,
    category: "DTC Launch",
    description: "Pet wellness provisions — ground-up Shopify build with subscriptions, bundle logic, and a brand system built to scale.",
    year: "2022",
    gradient: "linear-gradient(145deg, #0A0A0A 0%, #1a0d05 40%, #E8450E 100%)",
    size: "full",
    logo: elevatePetLogo,
  },
  {
    id: 10,
    client: "Longplay Wellness",
    image: thePacific,
    category: "Wellness DTC",
    description: "Modern wellness label — Shopify storefront with subscriptions, clean product architecture, and a calm, conversion-minded UX.",
    year: "2025",
    gradient: "linear-gradient(150deg, #0A0A0A 0%, #191006 45%, #E0500A 100%)",
    size: "half",
    logo: longplayLogo,
  },
  {
    id: 11,
    client: "Royo Bread Co",
    image: brownTee,
    category: "Ecommerce Launch",
    description: "DTC food brand launch with cold-chain logistics, subscription boxes, and wholesale portal.",
    year: "2022",
    gradient: "linear-gradient(140deg, #0A0A0A 0%, #1c1208 50%, #E8450E 100%)",
    size: "half",
    logo: royoLogo,
  },
  {
    id: 12,
    client: "Merkle",
    image: javascriptBird,
    category: "Enterprise CX",
    description: "Global customer experience agency — enterprise ecommerce builds and data-driven optimization for Fortune 500 retail brands.",
    year: "2020",
    gradient: "linear-gradient(140deg, #0A0A0A 0%, #150c05 40%, #F04E10 100%)",
    size: "full",
    logo: merkleLogo,
  },
  {
    id: 13,
    client: "Everyday Weed",
    image: reaperPattern,
    category: "Cannabis Retail",
    description: "Approachable cannabis brand — naming, identity, and an ecommerce experience built for the everyday customer.",
    year: "2025",
    gradient: "linear-gradient(160deg, #0A0A0A 0%, #180e05 50%, #D95000 100%)",
    size: "half",
    logo: everydayWeedLogo,
  },
  {
    id: 14,
    client: "Huskemaw Optics",
    image: towerPalms,
    category: "Shopify Build",
    description: "Precision long-range optics — Shopify build with spec-heavy product pages and a nationwide dealer locator.",
    year: "2023",
    gradient: "linear-gradient(130deg, #0A0A0A 0%, #120a04 45%, #E8560E 100%)",
    size: "half",
    logo: huskemawLogo,
  },
  {
    id: 15,
    client: "Green Dragon",
    image: palmFronds,
    category: "Dispensary Ecommerce",
    description: "Multi-state dispensary network — online ordering, store locator, and localized SEO across markets.",
    year: "2021",
    gradient: "linear-gradient(145deg, #0A0A0A 0%, #1a0c03 40%, #FF6326 100%)",
    size: "full",
    logo: greenDragonLogo,
  },
  {
    id: 16,
    client: "Coastal Division",
    image: thePacific,
    category: "Studio — Self-Initiated",
    description: "My own DTC consulting practice — the studio behind the work on this page. Brand, positioning, and site built end to end.",
    year: "Ongoing",
    gradient: "linear-gradient(135deg, #0A0A0A 0%, #1a1208 45%, #ED9764 100%)",
    size: "full",
    logo: "/coastal-division.svg",
    url: "https://coastaldivision.io",
  },
];

const pastClients = [
  { name: "Rhode", url: "https://www.rhodeskin.com/", logo: rhodeLogo, invert: true },
  { name: "Under Armour", url: "https://www.underarmour.com/en-us/", logo: underArmourLogo, invert: true },
  { name: "Samsung", url: "https://www.samsung.com/", logo: samsungLogo, invert: true },
  { name: "Comcast Business", url: "https://business.comcast.com/", logo: comcastLogo, invert: true },
  { name: "HexClad", url: "https://hexclad.com/", logo: hexcladLogo },
];

function Work() {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <main className="work">
      <div className="work__grain" />

      <section className="work__hero">
        <div className="work__hero-label">Selected Work</div>
        <h1 className="work__hero-title">
          Building brands<br />that sell
        </h1>
        <p className="work__hero-sub">
          A decade of DTC strategy, ecommerce builds, and brand growth across cannabis, CPG, and food & beverage.
        </p>
      </section>

      <section className="work__clients work__clients--top">
        <ClientMarquee />
      </section>

      <div className="work__divider" />

      <section className="work__grid">
        {projects.map((project, i) => {
          const Card = project.url ? "a" : "article";
          return (
            <Card
              className={`work__card work__card--${project.size}`}
              key={project.id}
              href={project.url}
              style={{ animationDelay: `${0.2 + i * 0.08}s` }}
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div
                className="work__card-image"
                style={{ background: project.gradient }}
              >
                <img
                  src={project.image}
                  alt=""
                  aria-hidden="true"
                  className="work__card-photo"
                  loading="lazy"
                />
                <div className="work__card-image-noise" />
                {project.logo ? (
                  <img
                    src={project.logo}
                    alt={`${project.client} logo`}
                    className={`work__card-logo ${project.logoInvert ? "work__card-logo--invert" : ""}`}
                    loading="lazy"
                  />
                ) : (
                  <span className="work__card-wordmark">{project.client}</span>
                )}
                <div className={`work__card-arrow ${hoveredId === project.id ? "work__card-arrow--visible" : ""}`}>
                  <FiArrowUpRight />
                </div>
                <div className="work__card-year">{project.year}</div>
              </div>
              <div className="work__card-info">
                <div className="work__card-header">
                  <h3 className="work__card-client">{project.client}</h3>
                  <span className="work__card-tag">{project.category}</span>
                </div>
                <p className="work__card-desc">{project.description}</p>
              </div>
            </Card>
          );
        })}
      </section>

      <section className="work__logos">
        <div className="work__logos-label">More Past Clients</div>
        <div className="work__logos-grid">
          {pastClients.map((client) => (
            <a
              className="work__logo-tile"
              key={client.name}
              href={client.url}
              aria-label={client.name}
            >
              <div className="work__card-image-noise" />
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                className={`work__logo-tile-img ${client.invert ? "work__logo-tile-img--invert" : ""}`}
                loading="lazy"
              />
            </a>
          ))}
        </div>
      </section>

      <div className="work__contact">
        <Contact />
      </div>
    </main>
  );
}

export default Work;
